<ng-container *transloco="let t">
  <section class="shipping-estimate-card">
    <div class="flex flex-col justify-center align-center icon-box" aria-hidden="true">
      <popsy-icon-shipping-box class="icon gray-dark"></popsy-icon-shipping-box>
    </div>
    <span class="fixed-space-24" aria-hidden="true"></span>
    <div class="flex flex-col justify-center align-start content">
      <span>{{ t('label_free_shippings_and_returns') }}</span>
      <popsy-skeleton class="mock" *ngIf="!(deliveryEstimate$ | async)"></popsy-skeleton>
      <span> {{ t('label_deliver_by') }} {{ deliveryEstimate$ | async }} </span>
    </div>
  </section>
</ng-container>
